module.exports = __webpack_public_path__ + "img/quayThresholdToVehicleMetro.9ff8949e.svg";